import shape from "../../assets/img/shapes/frame-shape-01.webp";


const FrameShape01 = () => {

    return (
        <div className="rmdr-frame-shape-01">
            <img src={shape} alt="rmdr-frame-shape-01" loading="lazy" width={240} height={234} />
        </div>
    )

}

export default FrameShape01;
